export default __webpack_public_path__ + "static/media/zingSleepGif.dc2d7a7c.gif";